<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3MqU2E/images/Cover.jpg?1735274501431" alt="This image is the cover for the book Hidden History of Henry County, Indiana, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of Henry County, Indiana, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p>The rural landscape of Henry County, Indiana, offers a bumper crop of captivating stories deeply rooted in history. <br/> John "Snowball" Merida's towering, crowd-thrilling home runs could have landed him in the Major Leagues were it not for his skin color. Native son Gen. Omar Bundy refused to retreat in World War I. His decision in all probability saved Paris from the Germans. A solitary chimney stack is an oddity in a green landscape, but it was in this spot more than a hundred years ago that a decision changed the course of New Castle history. <br/> Compiling stories of brave veterans and basketball heroes, nationally known catchphrases and political could-have-beens, author and local historian Darrel Radford uncovers lost gems from Henry County's past.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darrel Radford
      </h2>
      
      <p class="authorDescription body article">A lifelong resident of Henry County, Darrel Radford has been a journalist since his senior year at Blue River Valley High School nearly fifty years ago. With experience in newspapers, radio, magazines and politics, Radford says that he's never met a story assignment he didn't like. Author or coauthor of five books, Radford has had leadership roles on newspaper staffs in New Castle, Knightstown, Winchester and Hartford City and received numerous awards for his work. He continues to live in the New Castle area with his wife, Becky. They are parents of two children, Molly and Derek, as well as one grandchild, Claire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?199f96a2